const Modal = require('./modal');

const markup = `<db:spinner>
	<div data-id='message'>Loading ...</div>
	<div data-id='hourglassContainer'>
		<div data-id='hourglass'>👻</div>
	</div>
</db:spinner>`

module.exports = DomClass(markup, function() {
	var _t = this;

	Modal.call(this);

	on(this, 'open').then(function() {
	});

	on(this, 'close').then(function() {
		if (_t.parentNode) _t.parentNode.removeChild(_t);
	});

	document.body.appendChild(this);
	this.open();

});